export default __webpack_public_path__ + "static/media/ethereum.ec1c4fb9.png";